import { AxiosError } from 'axios';
import { useState } from 'react';

import { BaVerificationInterface } from '../../../models/dashboard/ba-verification/ba-verification';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { baVerificationStatsActions } from '../../../redux/slices/baVerificationStatsSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useBaVerificationStatsCard = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onStatsCardError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(
            err?.response?.data?.message ?? 'Something went wrong while fetching the stats.',
        );
    };

    const onStatsCardSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<BaVerificationInterface>) => {
        dispatch(baVerificationStatsActions.setVerificationStats(data));
    };

    const getBaVerificationStats = async () => {
        const url: HttpConfig = {
            url: `ba/v1/drivers/onboarding/statistics`,
            method: 'get',
        };

        request(url, onStatsCardSuccess, setLoading, onStatsCardError);
    };

    return { getBaVerificationStats, loading };
};

export default useBaVerificationStatsCard;
